import request from "@/utils/request";

export const getArchiveApps = ({ platform, search }) =>
  request.get("/archives/apps", {
    params: { platform, search },
  });

export const getArchives = ({
  bundle,
  platform,
  search,
  show_favourites,
  date_from,
  date_to,
  page,
  page_size,
}) =>
  request.get("/archives", {
    params: {
      ...(bundle ? { bundle } : {}),
      ...(platform ? { platform } : {}),
      ...(search ? { search } : {}),
      ...(show_favourites !== undefined && show_favourites !== null
        ? { show_favourites }
        : {}),
      ...(date_from ? { date_from } : {}),
      ...(date_to ? { date_to } : {}),
      ...(page !== undefined && page !== null ? { page } : {}),
      ...(page_size !== undefined && page_size !== null ? { page_size } : {}),
    },
  });

export const getArchive = (id) => request.get(`/archives/${id}`);

export const createArchive = (formData) =>
  request.post("/archives", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateArchive = (id, data) =>
  request.put(`/archives/${id}`, data);

export const deleteArchive = (id) => request.delete(`/archives/${id}`);

export const toggleFavorite = (id) =>
  request.post(`/archives/toggle-favourite/${id}`);

export const getPlatforms = () => request.get("/archives/platforms");

export const getBundles = () => request.get("/archives/bundles");

export const setNames = () => request.post("/archives/set-name");

export const getDownloadUrl = (archiveId) =>
  request.get("/download/url", {
    params: { archive_id: archiveId },
  });

export const getDownloadIpaUrl = (archiveId) =>
  request.get("/download/ipa/url", {
    params: { archive_id: archiveId },
  });

export const toggleMarkDelete = (id) =>
  request.post(`/archives/${id}/toggle-mark-delete`);
